import type {
  IVariable,
  ImageVariable,
  TextVariable,
} from '@carboncopyco/types';

export const isTextVariable = (variable: IVariable): variable is TextVariable =>
  variable.type === 'text';

export const isImageVariable = (
  variable: IVariable
): variable is ImageVariable => variable.type === 'image';

const isSameTextVariable = (var1: IVariable, var2: IVariable) =>
  isTextVariable(var1) &&
  isTextVariable(var2) &&
  (var1.variableId || var2.variableId
    ? var1.variableId === var2.variableId
    : var1.code === var2.code);

const isSameImageVariable = (var1: IVariable, var2: IVariable) =>
  isImageVariable(var1) &&
  isImageVariable(var2) &&
  var1.variableId === var2.variableId;

export const isSameVariable = (var1: IVariable, var2: IVariable) => {
  return isSameTextVariable(var1, var2) || isSameImageVariable(var1, var2);
};

export const addFileServiceDomainToImageVariables = ({
  variables,
  filesServiceDomain,
}: {
  variables: IVariable[];
  filesServiceDomain: string;
}) =>
  variables.filter(isImageVariable).map((variable) => ({
    ...variable,
    value: `${filesServiceDomain}${variable.value}`,
  }));
